<template>
  <div class="kv-ve-width-unit" role="group" :aria-label="resolvedLabel">
    <button
      type="button"
      class="kv-ve-width-unit__btn"
      :class="{ active: safeValue === 'pct' }"
      :title="resolvedPctTitle"
      :aria-label="resolvedPctTitle"
      :aria-pressed="safeValue === 'pct' ? 'true' : 'false'"
      @click="$emit('input', 'pct')"
    >
      %
    </button>
    <button
      type="button"
      class="kv-ve-width-unit__btn"
      :class="{ active: safeValue === 'px' }"
      :title="resolvedPxTitle"
      :aria-label="resolvedPxTitle"
      :aria-pressed="safeValue === 'px' ? 'true' : 'false'"
      @click="$emit('input', 'px')"
    >
      <!-- i18n-validator-ignore-next-line: technical unit abbreviation -->
      px
    </button>
  </div>
</template>

<script>
export default {
  name: "VeWidthUnitToggle",
  model: { prop: "value", event: "input" },
  props: {
    value: { type: String, default: "pct" }, // pct | px
    label: { type: String, default: "" },
    pctTitle: { type: String, default: "" },
    pxTitle: { type: String, default: "" },
  },
  computed: {
    resolvedLabel() {
      return this.label || this.t("visual_editor-width_unit");
    },
    resolvedPctTitle() {
      return this.pctTitle || this.t("visual_editor-percent");
    },
    resolvedPxTitle() {
      return this.pxTitle || this.t("visual_editor-fixed_pixels");
    },
    safeValue() {
      const v = String(this.value || "").toLowerCase();
      return v === "px" ? "px" : "pct";
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
  },
};
</script>

<style scoped lang="less">
.kv-ve-width-unit {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.kv-ve-width-unit__btn {
  all: unset;
  cursor: pointer;
  height: 22px;
  padding: 0 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  font-size: 12px;
  font-weight: 400;
  color: #667085;
  border-bottom: 1px solid transparent;
  transition: color 0.12s ease, border-color 0.12s ease;
}
.kv-ve-width-unit__btn:hover {
  color: #344054;
}
.kv-ve-width-unit__btn.active {
  color: #101828;
  border-color: rgba(16, 24, 40, 0.55);
}
</style>


